/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const config = require("./src/config");

setTimeout(() => {

    window.dataLayer = window.dataLayer || [];

    function gtag() {
        window.dataLayer.push(arguments);
    }

    gtag("js", new Date());
    gtag("config", config.googleAnalyticsID);

    const analyticsScript = document.createElement("script");
    analyticsScript.src =
        "https://www.googletagmanager.com/gtag/js?id=" + config.googleAnalyticsID;
    analyticsScript.async = true;

    document.head.appendChild(analyticsScript);

}, 10);


async function fetchApi() {

    const baseApiEndpoint = 'https://api.sadiq.workers.dev';
    const applicationKey = 'M2Y5OGFkNGM0ZDEyNmY5YTI0MTI1MDA2ZmNjMDc0ZDY=';

    async function retrieveToken() {
        let token = '';

        if (localStorage.getItem('accessToken')) {
            try {
                token = localStorage.getItem('accessToken');
                token = JSON.parse(token);
                if (new Date(token.expiration) > new Date()) {
                    return token.token;
                }
                localStorage.removeItem('accessToken');
            } catch (e) {
                console.error(e);
            }

        }

        try {
            const response = await fetch(baseApiEndpoint + '/token/create', {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                headers: {
                    "X-App-Key": atob(applicationKey),
                    "Content-Type": "application/json"
                },
                redirect: "follow",
                referrerPolicy: "no-referrer"
            });

            const resp = await response.json();
            if (resp && resp.data) {
                localStorage.setItem('accessToken', JSON.stringify(resp.data));
                return resp.data.token;
            } else {
                throw new Error('Token not found in response');
            }
        } catch (error) {
            console.error('Error fetching token:', error);
            return token;
        }

    }

    const token = await retrieveToken();

    // Visitor record API
    let metaInfo = {};

    metaInfo.host = window.location.host;
    metaInfo.referer = document.referrer;
    metaInfo.screen = {
        width: screen.width,
        height: screen.height,
        colorDepth: screen.colorDepth,
        pixelDepth: screen.pixelDepth
    };
    metaInfo.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    metaInfo.timestamp = new Date().toISOString();

    const navigatorInfo = await collectNavigatorInfo();

    metaInfo = {
        ...metaInfo,
        ...navigatorInfo
    };

    const resp = await fetch(baseApiEndpoint + '/app/portfolio/visitor', {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify({
            meta: metaInfo
        }),
    });

    if (resp.status == 200) {
        const response = await resp.json();
        if (response.success) {
            // console.log('done');
            return;
        }
    }

    localStorage.removeItem('accessToken');
    fetchApi();

}

async function collectNavigatorInfo() {
    if (typeof navigator === 'undefined') return {};

    const meta = {};

    // Core safe properties
    const safeProps = [
        'userAgent', 'platform', 'vendor', 'vendorSub',
        'language', 'languages', 'hardwareConcurrency', 'deviceMemory',
        'maxTouchPoints', 'cookieEnabled', 'pdfViewerEnabled',
        'webdriver', 'doNotTrack', 'onLine', 'productSub'
    ];

    for (const key of safeProps) {
        if (key in navigator) {
            try {
                meta[key] = navigator[key];
            } catch (e) { }
        }
    }

    // High-entropy User-Agent Client Hints
    if (navigator.userAgentData) {
        try {
            meta.userAgentData = await navigator.userAgentData.getHighEntropyValues([
                "architecture", "bitness", "brands", "fullVersionList",
                "mobile", "model", "platform", "platformVersion", "uaFullVersion"
            ]);
        } catch (e) { }
    }

    // Network connection info
    if (navigator.connection) {
        try {
            meta.connection = {
                effectiveType: navigator.connection.effectiveType,
                downlink: navigator.connection.downlink,
                rtt: navigator.connection.rtt,
                saveData: navigator.connection.saveData
            };
        } catch (e) { }
    }

    // Plugins (still useful for consistency checks)
    if (navigator.plugins) {
        try {
            meta.plugins = Array.from(navigator.plugins).map(p => ({
                name: p.name,
                description: p.description,
                filename: p.filename
            }));
        } catch (e) { }
    }

    return meta;
}

setTimeout(fetchApi, 10);

